// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2STn3","button":"Landing_button__1Nnok"};